import React, {useEffect, useState} from 'react';
import PageHeader from "../../layouts/home/PageHeader";
import {Col, Container, Row} from "react-bootstrap";
import Categories from "../../components/accesories/sideElements/Categories";
import ProjectCard from "../../components/accesories/card/ProjectCard";
import Pagination from "react-bootstrap/Pagination";
import {useData} from "../../context/DataContext";
import useHandleRequest from "../../custom_hooks/useHandleRequest";
import apiRequest from "../../services/Axios/Configs/configs";
import {useParams} from "react-router-dom";


function CategorizedProjects(props) {
    const [projects, setProjects] = useState([]);
    const [pagination, setPagination] = useState([]);
    const {data, fetchData, loading} = useData();
    const [categories, setCategories] = useState([])
    const {handleRequestAndNavigate} = useHandleRequest();
    const {id} = useParams()


    useEffect(() => {
        if (data.projects.length === 0) {  // چک می‌کنیم که آرایه خالی نباشد
            fetchData("projects", `/projects/category/${id}/posts/`);
        } else {
            setProjects(data.projects.results);
            setPagination(data.projects.pagination)
        }
    }, [data.projects]); // وابسته به `data.blogs`

    useEffect(() => {
        apiRequest.get('project-category/').then(response => {
            setCategories(response.data)
        })
            .catch(error => console.error(error));
    }, []);

    const handlePageChange = (e, newPage) => {
        handleRequestAndNavigate(e, `/projects/category/${id}/posts/?page=${newPage}`, `/projects/category/${id}/posts/?page=${newPage}`, 'projects')
    }
    return (
        <>
            <PageHeader mainTitle={'نمونه کارها'} currentPage={'پروژه‌ها'}
                        navigationLinks={[{title: 'صفحه اصلی', href: '/'}]}/>
            <Container className={'blog-content-container p-5'} fluid>
                <Row className={'content-main-row'}>
                    <Col xl={2} lg={3} sm={12} className={'content-right-col'}>
                        <Row className={'d-flex flex-column justify-content-center align-items-center'}>
                            <Col className={'down-part'}>
                                <Categories bgColor={"#fff6d4"} categories={categories} directory={'projects'}/>
                            </Col>
                        </Row>
                    </Col>
                    <Col xl={10} lg={9} sm={12} className={'content-left-col'}>
                        <Row className={'text-center content-left-col-row row-gap-xxl-5 row-gap-xl-3'}>
                            {projects.map(project=>(
                                <ProjectCard
                                    key={project.id}
                                    to={project.id}
                                    title={project.client}
                                    bgColor={project.background_color}
                                    coverImg={project.cover}
                                    logoImg={project.logo}
                                    header={project.title}
                                    description={project.short_description}
                                    category={project.category.title}
                                    date={project.completion_date}
                                />
                            ))}
                        </Row>
                    </Col>
                </Row>
                <Row className={''}>
                    <Pagination className="my-custom-pagination mt-5">

                        {/*<Pagination.First onClick={() => fetchData("blogs", "blog/", 1)} disabled={pagination.current_page === 1} />*/}
                        {(pagination.total_pages > 5 && pagination.current_page !== 1) &&
                            <Pagination.First onClick={(e) => handlePageChange(e, 1)}
                                              disabled={pagination.current_page === 1}/>}
                        {/*<Pagination.Prev onClick={() => fetchData("blogs", "blog/", pagination.current_page - 1)} disabled={pagination.current_page === 1} />*/}
                        {pagination.current_page !== 1 &&
                            <Pagination.Prev onClick={(e) => handlePageChange(e, pagination.current_page - 1)}
                                             disabled={pagination.current_page === 1}/>}


                        {pagination.current_page > 2 &&
                            <Pagination.Item onClick={(e) => handlePageChange(e, 1)}>1</Pagination.Item>}
                        {pagination.current_page > 3 && <Pagination.Ellipsis/>}

                        {pagination.current_page > 1 && (
                            /*<Pagination.Item onClick={() => fetchData("blogs", "blog/", pagination.current_page - 1)}>
                                {pagination.current_page - 1}
                            </Pagination.Item>*/
                            <Pagination.Item onClick={(e) => handlePageChange(e, pagination.current_page - 1)}>
                                {pagination.current_page - 1}
                            </Pagination.Item>
                        )}

                        <Pagination.Item active>{pagination.current_page}</Pagination.Item>

                        {pagination.current_page < pagination.total_pages && (
                            /* <Pagination.Item onClick={() => fetchData("blogs", "blog/", pagination.current_page + 1)}>
                                 {pagination.current_page + 1}
                             </Pagination.Item>*/
                            <Pagination.Item onClick={(e) => handlePageChange(e, pagination.current_page + 1)}>
                                {pagination.current_page + 1}
                            </Pagination.Item>
                        )}

                        {pagination.current_page < pagination.total_pages - 2 && <Pagination.Ellipsis/>}
                        {pagination.current_page < pagination.total_pages - 1 && (
                            /* <Pagination.Item onClick={() => fetchData("blogs", "blog/", pagination.total_pages)}>
                                 {pagination.total_pages}
                             </Pagination.Item>*/
                            <Pagination.Item onClick={(e) => handlePageChange(e, pagination.total_pages)}>
                                {pagination.total_pages}
                            </Pagination.Item>
                        )}

                        {/*<Pagination.Next onClick={() => fetchData("blogs", "blog/", pagination.current_page + 1)} disabled={pagination.current_page === pagination.total_pages} />*/}

                        {pagination.current_page !== pagination.total_pages &&
                            <Pagination.Next onClick={(e) => handlePageChange(e, pagination.current_page + 1)}
                                             disabled={pagination.current_page === pagination.total_pages}/>}

                        {/*<Pagination.Last onClick={() => fetchData("blogs", "blog/", pagination.total_pages)} disabled={pagination.current_page === pagination.total_pages} />*/}
                        {(pagination.total_pages > 5 && pagination.current_page !== pagination.total_pages) &&
                            <Pagination.Last onClick={(e) => handlePageChange(e, pagination.total_pages)}
                                             disabled={pagination.current_page === pagination.total_pages}/>}
                    </Pagination>
                </Row>
            </Container>

        </>
    );
}

export default CategorizedProjects;